import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Added Link import
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/6282226648077?text=Halo,%20saya%20butuh%20layanan%20AC', '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+6282226648077';
  };

  return (
    <header className="bg-background border-b border-border sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center space-x-2"> {/* Added Link component */}
                <img src="/assets/images/logo.png" alt="AssA AC Service Logo" className="w-10 h-10 object-contain" />
                <div className="flex flex-col">
                  <span className="font-heading font-bold text-lg text-primary">AssA AC</span>
                  <span className="font-heading font-semibold text-xs text-secondary -mt-1">Service</span>
                </div>
              </Link> {/* Closed Link component */}
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a 
              href="#" 
              className="text-foreground hover:text-primary font-medium transition-colors duration-200"
            >
              Beranda
            </a>
            <a 
              href="#layanan" 
              className="text-foreground hover:text-primary font-medium transition-colors duration-200"
            >
              Layanan
            </a>
            <a 
              href="#tentang" 
              className="text-foreground hover:text-primary font-medium transition-colors duration-200"
            >
              Tentang Kami
            </a>
            <a 
              href="#testimoni" 
              className="text-foreground hover:text-primary font-medium transition-colors duration-200"
            >
              Testimoni
            </a>
            <a 
              href="#kontak" 
              className="text-foreground hover:text-primary font-medium transition-colors duration-200"
            >
              Kontak
            </a>
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <Button
              variant="outline"
              onClick={handlePhoneClick}
              iconName="Phone"
              iconPosition="left"
                            className="font-heading font-semibold group"
            >
              <span className="text-accent font-bold group-hover:text-white">0822-2664-8077</span>
            </Button>
            <Button
              variant="default"
              onClick={handleWhatsAppClick}
              iconName="MessageCircle"
              iconPosition="left"
              className="bg-accent hover:bg-accent/90 hover:scale-105 font-heading font-semibold shadow-cta"
            >
              WhatsApp
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleMobileMenu}
              className="text-foreground hover:text-primary"
            >
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
            </Button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
                    <div className="absolute left-0 right-0 md:hidden border-t border-border bg-background shadow-lg">
            <div className="px-4 py-3 space-y-3">
              <a 
                href="#" 
                className="flex items-center text-foreground hover:text-primary font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Icon name="Home" size={20} className="mr-3" />
                Beranda
              </a>
              <a 
                href="#layanan" 
                className="flex items-center text-foreground hover:text-primary font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Icon name="Tool" size={20} className="mr-3" />
                Layanan
              </a>
              <a 
                href="#tentang" 
                className="flex items-center text-foreground hover:text-primary font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Icon name="Info" size={20} className="mr-3" />
                Tentang Kami
              </a>
              <a 
                href="#testimoni" 
                className="flex items-center text-foreground hover:text-primary font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Icon name="Star" size={20} className="mr-3" />
                Testimoni
              </a>
              <a 
                href="#kontak" 
                className="flex items-center text-foreground hover:text-primary font-medium py-2 transition-colors duration-200"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Icon name="Phone" size={20} className="mr-3" />
                Kontak
              </a>
              
              {/* Mobile CTA Buttons */}
              <div className="pt-3 border-t border-border space-y-2">
                <Button
                  variant="outline"
                  onClick={handlePhoneClick}
                  iconName="Phone"
                  iconPosition="left"
                  fullWidth
                  className="font-heading font-semibold justify-center"
                >
                  <span className="text-accent font-bold hover:text-white">0822-2664-8077</span>
                </Button>
                <Button
                  variant="default"
                  onClick={handleWhatsAppClick}
                  iconName="MessageCircle"
                  iconPosition="left"
                  fullWidth
                  className="bg-accent hover:bg-accent/90 font-heading font-semibold shadow-cta justify-center"
                >
                  WhatsApp Sekarang
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
